import empresaSchema from "@/modules/projetos/schema/empresa-schema";

const inviteEmpresaSchema = empresaSchema.pick([]);

export default inviteEmpresaSchema;
